export const ACTION_CHANGE_PASSWORD = '/Account/ChangePassword';